import { isRhinoNetworkError, isRhinoTimeoutError } from '../../../error';
import { pingSystem as requestSystemPing } from '../../services/system';

export type CheckNetworkConnectionArgs = {
  timeout: number;
};

export async function checkNetworkConnection({ timeout }: CheckNetworkConnectionArgs = { timeout: 5000 }) {
  try {
    await requestSystemPing({ timeout });

    return true;
  } catch (e) {
    return !isRhinoNetworkError(e) && !isRhinoTimeoutError(e);
  }
}
